import { SxProps, useTheme } from "@mui/material";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";

export const useTreeLayoutClasses = () => {
    const theme = useTheme();
    const classes = {

        root: {

            ".MuiTreeItem-groupTransition": {
                paddingLeft: '20px',
            },

            ".MuiTreeItem-content": {
                padding: "4px 6px",

                "&.Mui-focused":{
                    backgroundColor: 'transparent',
                },

                "&:hover": {
                    backgroundColor: 'transparent !important',

                    ".MuiTreeItem-label": {
                        textDecoration: "underline",
                    },

                    ".MuiTreeItem-label, .MuiTreeItem-iconContainer svg": {
                        color: StyleguideSavioColors.blue,
                    }
                },

                ".MuiTreeItem-iconContainer svg": { fontSize: 26, color: StyleguideSavioColors.text.black, },

                "&.Mui-selected ": {
                    backgroundColor: 'transparent !important',
                    ".MuiTreeItem-label, .MuiTreeItem-iconContainer svg": {
                        //color: StyleguideSavioColors.blue,
                        fontWeight: StyleguideSavioFonts.bold,

                    },

                    "&:nth-last-of-type(1) .MuiTreeItem-label":{
                        //color: StyleguideSavioColors.text.black + ' !important',
                    }

                },
                ".MuiTreeItem-label": {
                    fontSize: 14,
                    color: StyleguideSavioColors.text.black,
                },
            },

            "> li:first-of-type >.MuiTreeItem-content ": {
                ".MuiTreeItem-label": {
                    fontWeight: StyleguideSavioFonts.bold
                },
                "svg": { display: "none ", }
            },
        } as SxProps,
        selected: {
            color: StyleguideSavioColors.mainBlue + " !important",
        } as SxProps

    }
    return classes;
};
